var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerNightIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_4108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4284 10.0001C11.4352 8.26811 11.8916 6.56758 12.753 5.06504C13.6145 3.5625 14.8514 2.30946 16.3427 1.42864C15.2369 0.970806 14.0538 0.728368 12.857 0.714355C10.3943 0.714355 8.03242 1.69267 6.29102 3.43408C4.5496 5.17548 3.57129 7.53734 3.57129 10.0001C3.57129 12.4628 4.5496 14.8246 6.29102 16.5661C8.03242 18.3075 10.3943 19.2858 12.857 19.2858C14.0682 19.2772 15.2664 19.0346 16.3856 18.5715C14.8863 17.6961 13.6408 16.4454 12.7717 14.9424C11.9025 13.4395 11.4396 11.7362 11.4284 10.0001Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_4108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerNightIcon);
export default __webpack_public_path__ + "static/media/PerNightIcon.6e0d2b8b839020b4754ad4d82a34b494.svg";
export { ForwardRef as ReactComponent };